@if (isLoading()) {
    <div class="scout-ai-loading-overlay">
        <div class="scout-ai-spinner" role="status">
            <span class="scout-ai-sr-only">Loading assistant...</span>
        </div>
        <p>Connecting to assistant...</p>
    </div>
}

@if (errorMessage() && !isLoading()) {
    <div class="scout-ai-error-container">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <p>{{ errorMessage() }}</p>
        <button class="scout-ai-btn-retry" (click)="retry()">Retry</button>
    </div>
}

@if (!errorMessage()) {
    <app-scout-ai-message-view
        [activities]="directLineService.activities()"
        [suggestedActions]="directLineService.suggestedActions()"
        [isWaitingForResponse]="directLineService.isWaitingForResponse()"
        [userId]="userId"
        [sessionEnded]="directLineService.sessionEnded()"
        (sendMessage)="onSendMessage($event)"
        (suggestedActionClick)="onSuggestedActionClick($event)"
        (newConversation)="onNewConversation()">
    </app-scout-ai-message-view>
}
